module.exports = __webpack_public_path__ + "img/675623afd3b6d6c224aa55924b53e6af.png";